import {
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContentText,
  Switch,
  TextField,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Straight } from "@mui/icons-material";
import { FranquiaService, IDadosDisponibilizacaoJogador, IDadosMultasJogador } from "../../services/api/franquia/FranquiaService";
import { moedaRealLocaleValue, moedaRealLocaleValueEdit } from "../input-valor-moeda/Current-Mask";
import { DialogMensagem, IDadosModal } from "./DialogMensagem";
import CookieService from "../../services/autenticacao/CookieService";

import { IListaDadosLanceFreeAgency } from "../../services/api/freeAgency/FreeAgencyService";
import { AnosTemporadas, UtilidadeService, enumFormasPagamento, lstDropTipoContratoAjustado, tipoDisponibilizacaoJogador } from "../../services/api/utilidades/UtilidadesService";

import { IDetalheJogadorFreeAgency, JogadorService } from "../../services/api/jogador/JogadorService";
import { PropostaService } from "../../services/api/propostas/PropostaService";
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { FinanceiroService, IDadosBaixaFinanceiro, IDadosCadastroFinanceiro, IListaDadosCadastroFinanceiro } from "../../services/api/financeiro/FinanceiroService";
import { ApostaService } from "../../services/api/apostas/ApostasService";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export interface IDadosModalEvento {
  mensagem: string;
  label: string;
  titulo: string;
  acao: boolean;
  display: string;
  tipo: "error" | "warning" | "info" | "success";
  evento?: string;
  info?: any;

}
export type IModalProps = {
  dados: IDadosModalEvento;
  children?: React.ReactNode;
  isModalVisible: boolean;
  onBackClickClose: () => void;
}

interface IDadosTiposContratoAjustavel {
  codigo: number;
  tipo: string;
  ano1: string;
  ano2: string;
  ano3: string;
  ano4: string;
  ano5: string;
  total: string;
}

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}

        thousandSeparator={'.'}
        decimalSeparator={','}
        valueIsNumericString
        prefix="R$"
      />
    );
  },
);


export const DialogEvent: React.FC<IModalProps> = ({ dados, onBackClickClose, isModalVisible }) => {
  const [open, setOpen] = React.useState(isModalVisible);
  const [checked, setChecked] = React.useState(false);
  const navigate = useNavigate();
  const [dadosMultasJogador, setDadosMultasJogador] = useState<IDadosMultasJogador[]>([])
  const [showDispensarJogador, setShowDispensarJogador] = useState(false);
  const [showLanceFreeAgency, setShowLanceFreeAgency] = useState(false);
  const [showSolicitacaoPagamento, setShowSolicitacaoPagamento] = useState(false);
  const [showBaixaFinanceiro, setShowBaixaFinanceiro] = useState(false);
  const [showDisponibilizarJogador, setShowDisponibilizarJogador] = useState(false);
  const [showAlterarContratoJogador, setShowAlterarContratoJogador] = useState(false);
  const [showCancelarAposta, setShowCancelarAposta] = useState(false);

  const [dadosLance, setDadosLance] = useState<IListaDadosLanceFreeAgency>();
  const [dadosSolicitacaoPagamento, setDadosSolicitacaoPagamento] = useState<IListaDadosCadastroFinanceiro>();
  const [dadosFinanceiro, setDadosFinanceiro] = useState<IDadosCadastroFinanceiro>();
  const [dadosDisponibilizarJogador, setDadosDisponibilizarJogador] = useState<any>();
  const [dadosAlterarContratoJogador, setDadosAlterarContratoJogador] = useState<any>();
  const [dadosCancelarAposta, setDadosCancelarAposta] = useState<any>();
  const [showImagemJogador, setShowImagemJogador] = useState<any>("../../semimagem.png");
  const [tipoPagamento, setTipoPagamento] = useState(0);

  const [dadosExclusao, setDadosExclusao] = useState<any>();
  const [lanceAnoSelecionado, setLanceAnoSelecionado] = useState(0);
  const [lanceAnoSelecionadoFA, setLanceAnoSelecionadoFA] = useState(0);
  const [lanceValor, setLanceValor] = useState<string>("0")
  const [porcentagemContratoAjustavel, setPorcentagemContratoAjustavel] = useState(0);
  const [lanceNomeJogador, setLanceNomeJogador] = useState("")
  const [tipoAtivoTroca, setTipoAtivoTroca] = useState(0)
  const [opcaoContratoAjustavel, setOpcaoContratoAjustavel] = useState<number>(1);
  const [showExcluirProposta, setShowExcluirProposta] = useState(false);
  const [showMultasJogador, setShowMultasJogador] = useState(false);
  const [redirecionar, setRedirecionar] = useState("");
  const [showModalMensagem, setShowModalMensagem] = useState(false);
  const [franquiaAtual, setFranquiaAtual] = useState(0);
  const [valorPagamento, setValorPagamento] = useState(0);
  const [tipoFreeAgency, setTipoFreeAgency] = useState(0);
  const [descontoPagamento, setDescontoPagamento] = useState(0);
  const [formaPagamento, setFormaPagamento] = useState(0);
  const [desativar, setDesativar] = useState(false);
  const [showOpcaoContrato, setShowOpcaoContrato] = useState(false);
  const [show, setShow] = useState(false);
  const [anoSelecionado, setAnoSelecionado] = useState<number>(0);
  const [opcoesContratoAjustavelRows, setOpcoesContratoAjustavelRows] = useState<IDadosTiposContratoAjustavel[]>([]);
  const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
    acao: false,
    label: "",
    tipo: "error",
    mensagem: "Sessão Expirada!",
    display: "none",
    titulo: "Atenção"
  });

  useEffect(() => {
    if (!isModalVisible) {
      return;
    }
    else {
      if (dados !== undefined && dados.evento === "dispensarJogador") {
        setShowDispensarJogador(true);
        setShowMultasJogador(false);
        setShow(true);
        return;
      }
      if (dados !== undefined && dados.evento === "multasJogador") {
        setShowDispensarJogador(false);
        setShowMultasJogador(true);
        FranquiaService.dadosDetalhadosMultasJogador(dados.info.codigoFranquia)
          .then((result) => {
            setDadosMultasJogador(result.dado);
            setShowDispensarJogador(false);
            setShowMultasJogador(true);
            setShow(true);
          })
          .catch((errors) => {
            // setShowModalMensagem(true);

            // if (errors.response.data.statusHTTP === 401) {
            //     setDadosModalMensagem({
            //         acao: true,
            //         label: "",
            //         tipo: "error",
            //         mensagem: "Sessão expirada!",
            //         display: "none",
            //         titulo: "Atenção"
            //     });
            //     logout();
            //     setRedirecionar("0");
            //     return;
            // }
            // setDadosModalMensagem({
            //     acao: true,
            //     label: "",
            //     tipo: "error",
            //     mensagem: errors.response.data.mensagem,
            //     display: "none",
            //     titulo: "Atenção"
            // });
          });
        return;
      }
      if (dados !== undefined && dados.evento === "lanceFreeAgency") {        
        setDadosLance(dados.info.dadosLance[0]);
        setShowLanceFreeAgency(true);
        setLanceNomeJogador(dados.info.dadosLance.nome_Jogador);
        setLanceAnoSelecionadoFA(dados.info.dadosLance.tempo_Contrato);
        setLanceValor(dados.info.dadosLance.valor_Ultimo_Contrato_Jogador);
        setFranquiaAtual(dados.info.codigoFranquia);
        setShowOpcaoContrato(dados.info.tipoFreeAgency === 3);
        setOpcaoContratoAjustavel(dados.info.codigoTipoPosicaoConfronto);
        setTipoFreeAgency(dados.info.tipoFreeAgency);
        setPorcentagemContratoAjustavel(dados.info.porcentagemContratoAjustavel);
        setShow(true);
        return;
      }
      if (dados !== undefined && dados.evento === "excluirProposta") {
        setShowExcluirProposta(true);
        setDadosExclusao(dados.info);
        setShow(true);
        return;
      }
      if (dados !== undefined && dados.evento === "solicitarPagamento") {
        setDadosSolicitacaoPagamento(dados.info.dadosPagamento)
        setShowSolicitacaoPagamento(true);
        setShow(true);
        return;
      }
      if (dados !== undefined && dados.evento === "baixaFinanceiro") {
        setShowBaixaFinanceiro(true);
        setDadosFinanceiro(dados.info);
        setShow(true);
        return;
      }
      if (dados !== undefined && dados.evento === "disponibilizarJogador") {
        setShowDisponibilizarJogador(true);
        setDadosDisponibilizarJogador(dados.info);
        setShow(true);
        return;
      }
      if (dados !== undefined && dados.evento === "twoWayJogador") {
        setShowAlterarContratoJogador(true);
        setDadosAlterarContratoJogador(dados.info);
        setShow(true);
        return;
      }

       if (dados !== undefined && dados.evento === "cancelarAposta") {
        setShowCancelarAposta(true);
        setDadosCancelarAposta(dados.info);
        setShow(true);
        return;
      }
      setShow(false);
    }
    return;
  }, [dados]);

  const handleClickOpen = () => {
    setOpen(true);
    onBackClickClose();
  };

  const handleClose = () => {
    setOpen(false);
    onBackClickClose();

  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    if (dados.evento === "renovarJogador") {
      //alert(dados.evento + " - " + event.target.checked);
    }
    if (dados.evento === "dispensarJogador") {

      FranquiaService.dispensarJogadorFranquia(dados.info.codigoJogador, dados.info.codigoFranquia)
        .then((result) => {
          setShowModalMensagem(true);
          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "success",
            mensagem: "Jogador dispensado com sucesso!",
            display: "none",
            titulo: "Atenção"
          });
          setRedirecionar("0");
        })
        .catch((errors) => {
          setShowModalMensagem(true);
          //setIsLoading(false);
          if (errors.response !== undefined) {
            //if (errors.response.data.statusHTTP === 401) {
            //     setDadosModalMensagem({
            //         acao: true,
            //         label: "",
            //         tipo: "error",
            //         mensagem: "Sessão expirada!",
            //         display: "none",
            //         titulo: "Atenção"
            //     });
            //     logout();
            //     setRedirecionar("0"); 
            //     return;
            // }
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            return;
          }
          handleClose();
        });
    }
  };


  const handleMaskChange = (e: any) => {
    let valor = e.target.value;

    if (valor !== null) {
      valor = moedaRealLocaleValueEdit(valor);
    }

    setLanceValor(valor);
  }

  const toggleModalMensagem = () => {
    setShowModalMensagem(modalVisivel => !modalVisivel);
    handleClose();
    // if (redirecionar.length === 1 || CookieService.get("access_token") === undefined) {
    //navigate(0);
    //}
    //else {
    // navigate("/liga/freeagency/detalhe");
    // }
  }

  const handleSalvarLance = async () => {
    setDesativar(true);
    const porcentagem = porcentagemContratoAjustavel;
    const valorPorTempo = Number(lanceValor);

    const opcoes = ([
      {
        codigo: 1,
        tipo: "Linear",
        ano1: lanceValor.toString(),
        ano2: lanceAnoSelecionadoFA > 1 ? lanceValor.toString() : "0",
        ano3: lanceAnoSelecionadoFA > 2 ? lanceValor.toString() : "0",
        ano4: lanceAnoSelecionadoFA > 3 ? lanceValor.toString() : "0",
        ano5: lanceAnoSelecionadoFA > 4 ? lanceValor.toString() : "0",
        total: Number(Number(lanceValor) * lanceAnoSelecionadoFA).toString()
      },
      {
        codigo: 2,
        tipo: "Progressivo",
        ano1: lanceAnoSelecionadoFA === 1 ? valorPorTempo.toString() : lanceAnoSelecionadoFA === 2 ? Number(valorPorTempo - Number(Number(valorPorTempo * porcentagem) / 100)).toString() : lanceAnoSelecionadoFA === 3 ? Number(valorPorTempo - Number(Number(valorPorTempo * porcentagem) / 100)).toString() : Number(valorPorTempo - Number(Number(valorPorTempo * Number(porcentagem * 2)) / 100)).toString(),
        ano2: lanceAnoSelecionadoFA > 1 ? lanceAnoSelecionadoFA === 2 ? Number(valorPorTempo + Number(Number(valorPorTempo * porcentagem) / 100)).toString() : lanceAnoSelecionadoFA === 3 ? valorPorTempo.toString() : Number(valorPorTempo - Number(Number(valorPorTempo * porcentagem) / 100)).toString() : "0",
        ano3: lanceAnoSelecionadoFA > 2 ? lanceAnoSelecionadoFA === 4 ? Number(valorPorTempo + Number(Number(valorPorTempo * porcentagem) / 100)).toString() : lanceAnoSelecionadoFA === 3 ? Number(valorPorTempo + Number(Number(valorPorTempo * porcentagem) / 100)).toString() : valorPorTempo.toString() : "0",
        ano4: lanceAnoSelecionadoFA > 3 ? lanceAnoSelecionadoFA === 4 ? Number(valorPorTempo + (Number(lanceValor) * Number(porcentagem * 2)) / 100).toString() : Number(valorPorTempo + Number(Number(valorPorTempo * porcentagem) / 100)).toString() : "0",
        ano5: lanceAnoSelecionadoFA > 4 ? Number(valorPorTempo + (Number(lanceValor) * Number(porcentagem * 2)) / 100).toString() : "0",
        total: Number(Number(lanceValor) * lanceAnoSelecionadoFA).toString()
      },
      {
        codigo: 3,
        tipo: "Regressivo",
        ano1: lanceAnoSelecionadoFA === 1 ? valorPorTempo.toString() : lanceAnoSelecionadoFA === 2 ? Number(valorPorTempo + Number(Number(valorPorTempo * porcentagem) / 100)).toString() : lanceAnoSelecionadoFA === 3 ? Number(valorPorTempo + Number(Number(valorPorTempo * porcentagem) / 100)).toString() : Number(valorPorTempo + ((Number(lanceValor)) * (porcentagem * 2)) / 100).toString(),
        ano2: lanceAnoSelecionadoFA > 1 ? lanceAnoSelecionadoFA === 2 ? Number(valorPorTempo - Number(Number(valorPorTempo * porcentagem) / 100)).toString() : lanceAnoSelecionadoFA === 3 ? valorPorTempo.toString() : Number(valorPorTempo + Number(Number(valorPorTempo * porcentagem) / 100)).toString() : "0",
        ano3: lanceAnoSelecionadoFA > 2 ? lanceAnoSelecionadoFA === 4 ? Number(valorPorTempo - Number(Number(valorPorTempo * porcentagem) / 100)).toString() : lanceAnoSelecionadoFA === 3 ? Number(valorPorTempo - Number(Number(valorPorTempo * porcentagem) / 100)).toString() : valorPorTempo.toString() : "0",
        ano4: lanceAnoSelecionadoFA > 3 ? lanceAnoSelecionadoFA === 4 ? Number(valorPorTempo - Number(Number(valorPorTempo * Number(porcentagem * 2)) / 100)).toString() : Number(valorPorTempo - Number(Number(valorPorTempo * porcentagem) / 100)).toString() : "0",
        ano5: lanceAnoSelecionadoFA > 4 ? Number(valorPorTempo - Number(Number(valorPorTempo * Number(porcentagem * 2)) / 100)).toString() : "0",
        total: Number(Number(lanceValor) * lanceAnoSelecionadoFA).toString()
      }
    ]);
    const valores = opcoes.find(f => f.codigo === opcaoContratoAjustavel);
    const dadosSalvar: IDetalheJogadorFreeAgency = {
      codigo_Franquia: franquiaAtual,
      codigo_Free_Agency: dadosLance !== undefined ? dadosLance?.codigo_Free_Agency : 0,
      codigo_Jogador: dadosLance !== undefined ? dadosLance?.codigo_Jogador : 0,
      tempo_Contrato: lanceAnoSelecionadoFA,
      valor: lanceValor.split(".")[0],
      codigo_Tipo_Contrato_Ajustavel: tipoFreeAgency === 3 ? opcaoContratoAjustavel : null,
      valor_Ajustavel_Ano1: tipoFreeAgency === 3 ? valores?.ano1 === "0" ? null : valores?.ano1 : null,
      valor_Ajustavel_Ano2: tipoFreeAgency === 3 ? valores?.ano2 === "0" ? null : valores?.ano2 : null,
      valor_Ajustavel_Ano3: tipoFreeAgency === 3 ? valores?.ano3 === "0" ? null : valores?.ano3 : null,
      valor_Ajustavel_Ano4: tipoFreeAgency === 3 ? valores?.ano4 === "0" ? null : valores?.ano4 : null,
      valor_Ajustavel_Ano5: tipoFreeAgency === 3 ? valores?.ano5 === "0" ? null : valores?.ano5 : null
    }
    await JogadorService.CreateJogadorFreeAgency(dadosSalvar)
      .then((result) => {
        setShowModalMensagem(true);
        setDadosModalMensagem({
          acao: true,
          label: "",
          tipo: "success",
          mensagem: "Lance atualizado com sucesso!",
          display: "none",
          titulo: "Atenção"
        });
        navigate(0);
      })
      .catch((errors) => {
        setShowModalMensagem(true);
        if (errors.response !== undefined) {
          if (errors.response.status === 401) {
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: "Sessão expirada!",
              display: "none",
              titulo: "Atenção"
            });
            setRedirecionar("0");
            return;
          }
          else {
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            //setRedirecionar("0");
            return;
          }
        }
        setDadosModalMensagem({
          acao: true,
          label: "",
          tipo: "error",
          mensagem: "Não foi possível cadastrar os dados do lance! Favor entrar em contato com a TI.",
          display: "none",
          titulo: "Atenção"
        });
      });
  }

  const handleExcluirProposta = () => {
    PropostaService.deleteById(dadosExclusao.codigo, dadosExclusao.codigoFranquia)
      .then((result) => {

        setShowModalMensagem(true);
        setDadosModalMensagem({
          acao: true,
          label: "",
          tipo: "success",
          mensagem: "Proposta excluida com sucesso!",
          display: "none",
          titulo: "Sucesso!"
        });
        setRedirecionar("0");
      })
      .catch((errors) => {

        setShowModalMensagem(true);
        setDadosModalMensagem({
          acao: true,
          label: "",
          tipo: "error",
          mensagem: "Não foi possível excluir a proposta! Favor tentar mais tarde.",
          display: "none",
          titulo: "Atenção!"
        });
        setRedirecionar("0");
      });
  }

  const handleSolicitarPagamento = () => {
    if (dadosSolicitacaoPagamento !== undefined) {
      // FinanceiroService.Create(dadosSolicitacaoPagamento)
      //   .then((result) => {
      //     setShowModalMensagem(true);
      //     setDadosModalMensagem({
      //       acao: true,
      //       label: "",
      //       tipo: "success",
      //       mensagem: "Solicitação realziada com sucesso! Seráe enviado no seu e-mail / WhatsApp.",
      //       display: "none",
      //       titulo: "Sucesso!"
      //     });
      //     setRedirecionar("0");
      //   })
      //   .catch((errors) => {

      //     setShowModalMensagem(true);
      //     setDadosModalMensagem({
      //       acao: true,
      //       label: "",
      //       tipo: "error",
      //       mensagem: "Não foi possível realizar a solicitação! Favor tentar mais tarde.",
      //       display: "none",
      //       titulo: "Atenção!"
      //     });
      //     setRedirecionar("0");
      //   });
    }
  }

  const handleBaixarFinanceiro = () => {
    setDesativar(true);
    if (dadosFinanceiro !== undefined) {
      var dadosPagamento: IDadosCadastroFinanceiro = {
        codigo_Liga: dados.info.codigoLiga,
        codigo_Usuario: dados.info.codigoUsuario,
        codigo_Franquia: dados.info.codigoFranquia,
        codigo_Temporada: dados.info.codigoTemporada,
        codUsuCriacao: dados.info.codUsuCriacao,
        forma_Pagamento: formaPagamento === 0 ? 4 : formaPagamento,
        codigo_Premiacao: 0,
        observacao: "Baixa direta pelo administrador",
        situacao: true,
        status: 5,
        valor: valorPagamento,
        desconto: descontoPagamento
      }

      FinanceiroService.CreateBaixaPagamento(dadosPagamento)
        .then((result) => {

          setShowModalMensagem(true);
          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "success",
            mensagem: "Baixa realizada com sucesso!",
            display: "none",
            titulo: "Sucesso!"
          });
          setRedirecionar("0");
        })
        .catch((errors) => {
          if (errors.response !== undefined) {
            if (errors.response.data.statusHTTP === 401) {
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
              });
              setRedirecionar("0");;
              return;
            }
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            return;
          }
          else {
            setShowModalMensagem(true);
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: "Não foi possível realizar a baixa do financeiro! Favor tentar mais tarde.",
              display: "none",
              titulo: "Atenção!"
            });
            return;
          }
        });
    }

  }

  const handleDisponibilizarJogador = async () => {
    setDesativar(true);
    const user = CookieService.get("access_user");
    if (dadosDisponibilizarJogador !== undefined) {
      var dados: IDadosDisponibilizacaoJogador = {
        codigo_Franquia: dadosDisponibilizarJogador.codigoFranquia,
        codigo_Usuario: user.codUsuario,
        codigo_Jogador: dadosDisponibilizarJogador.codigoJogador,
        codigo_Tipo_Ativo_Troca: tipoAtivoTroca === 0 ? null : tipoAtivoTroca
      }

      await FranquiaService.disponibilizarJogador(dados)
        .then((result) => {
          setShowModalMensagem(true);
          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "success",
            mensagem: "Processo realizado com sucesso!",
            display: "none",
            titulo: "Atenção!"
          });
          setRedirecionar("0");
          return;
        })
        .catch((errors) => {
          setShowModalMensagem(true);
          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "error",
            mensagem: "Não foi possível disponibilizar! Favor tentar mais tarde.",
            display: "none",
            titulo: "Atenção!"
          });
          return;
        });
    }
  }

  const handleAlterarContratoJogador = () => {
    FranquiaService.updateFranquiaTwoWay(dadosAlterarContratoJogador.codigoLiga, dadosAlterarContratoJogador.codigoFranquia, dadosAlterarContratoJogador.codigoJogador)
      .then((result) => {
        setShowModalMensagem(true);
        setDadosModalMensagem({
          acao: true,
          label: "",
          tipo: "success",
          mensagem: "Contrato alterado com sucesso!",
          display: "none",
          titulo: "Atenção"
        });
        navigate(0);
      })
      .catch((errors) => {
        setShowModalMensagem(true);
        if (errors.response.data.statusHTTP === 401) {
          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "error",
            mensagem: "Sessão expirada!",
            display: "none",
            titulo: "Atenção"
          });
          setRedirecionar("0");;
          return;
        }
        setDadosModalMensagem({
          acao: true,
          label: "",
          tipo: "error",
          mensagem: errors.response.data.mensagem,
          display: "none",
          titulo: "Atenção"
        });
      });
  }

  const handleCancelarAposta = () => {
    ApostaService.deleteById(dadosCancelarAposta.codigo)
      .then((result) => {
        setShowModalMensagem(true);
        setDadosModalMensagem({
          acao: true,
          label: "",
          tipo: "success",
          mensagem: "Aposta cancelada com sucesso!",
          display: "none",
          titulo: "Sucesso!"
        });
        setRedirecionar("0");
      })
      .catch((errors) => {
        setShowModalMensagem(true);
        setDadosModalMensagem({
          acao: true,
          label: "",
          tipo: "error",
          mensagem: "Não foi possível cancelar a aposta! Favor tentar mais tarde.",
          display: "none",
          titulo: "Atenção!"
        });
        setRedirecionar("0");
      });
  }
  return (
    <div style={{ display: show ? "flow" : "none" }} >
      {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
      <Button variant="outlined" onClick={handleClickOpen} sx={{ display: dados.display }}>
        {dados.label}
      </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={show ? open : false}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          {dados.titulo}
        </BootstrapDialogTitle>
        <DialogContent dividers sx={{ minWidth: UtilidadeService.isMobile() ? "300px" : "500px", fontSize: UtilidadeService.isMobile() ? 14 : "auto" }}>
          <DialogContentText>
            <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 14 : "auto" }}>
              {dados.mensagem}
            </Typography>
            {showDispensarJogador && !showMultasJogador && dados.info.mensagemAdicional !== undefined &&
              dados.info.mensagemAdicional.split("|").map((men: any) => (
                <Grid container direction="column">
                  <Grid container size={{ xs: 12, sm: 12 }} >
                    <Grid size={{ xs: 12, sm: 3 }} >
                      {men.split(":")[0]}:
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }} >
                      <Typography sx={dados.info.style !== undefined ? dados.info.style : null}>
                        {men.split(":")[1]}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              ))
            }
            {!showDispensarJogador && showMultasJogador && dadosMultasJogador.length > 0 ? dadosMultasJogador.map(mul => (
              <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={3}>
                <Grid container size={{ xs: 12, sm: 12 }} spacing={2}>
                  <Grid size={{ xs: 12, sm: 12 }} >
                    <Typography>
                      <img src={mul.foto_Jogador === null ? showImagemJogador : mul.foto_Jogador} alt={mul.nome_Jogador} width={UtilidadeService.isMobile() ? 35 : 50} height={UtilidadeService.isMobile() ? 35 : 50}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = "../../../../semimagem.png";
                          currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                          currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                        }}

                      /> {mul.nome_Jogador}
                    </Typography>
                  </Grid>
                  <Grid container size={{ xs: 12, sm: 12 }} >
                    {mul.multa_Ano1.toString().trim() !== "0" ?
                      <Grid size={{ xs: 12, sm: 4 }} direction="column">
                        <Typography sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                          {mul.descricao_Multa_Ano1}
                        </Typography>
                        <Typography sx={{ color: "red", fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                          R${moedaRealLocaleValue(mul.multa_Ano1)}
                        </Typography>
                      </Grid> : null}
                    {mul.multa_Ano2.toString().trim() !== "0" ?
                      <Grid size={{ xs: 12, sm: 4 }} direction="column">
                        <Typography sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                          {mul.descricao_Multa_Ano2}
                        </Typography>
                        <Typography sx={{ color: "red", fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                          R${moedaRealLocaleValue(mul.multa_Ano2)}
                        </Typography>
                      </Grid> : null}
                    {mul.multa_Ano3.toString().trim() !== "0" ?
                      <Grid size={{ xs: 12, sm: 4 }} direction="column">
                        <Typography sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                          {mul.descricao_Multa_Ano3}
                        </Typography>
                        <Typography sx={{ color: "red", fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                          R${moedaRealLocaleValue(mul.multa_Ano3)}
                        </Typography>
                      </Grid> : null}
                    {mul.multa_Ano4.toString().trim() !== "0" ?
                      <Grid size={{ xs: 12, sm: 4 }} direction="column">
                        <Typography sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                          {mul.descricao_Multa_Ano4}
                        </Typography>
                        <Typography sx={{ color: "red", fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                          R${moedaRealLocaleValue(mul.multa_Ano4)}
                        </Typography>
                      </Grid> : null}
                    {mul.multa_Ano5.toString().trim() !== "0" ?
                      <Grid size={{ xs: 12, sm: 4 }} direction="column">
                        <Typography sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                          {mul.descricao_Multa_Ano5}
                        </Typography>
                        <Typography sx={{ color: "red", fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                          R${moedaRealLocaleValue(mul.multa_Ano5)}
                        </Typography>
                      </Grid> : null}
                  </Grid>
                </Grid>
              </Grid>
            )) : !showDispensarJogador && showMultasJogador &&
            <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
              Não existe(m) multa(s)!
            </Typography>
            }
            {showSolicitacaoPagamento && (
              <Grid size={{ xs: 12, sm: 6, md: 6 }} >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Anos</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Anos"
                    value={lanceAnoSelecionado}
                    onChange={(e) => setLanceAnoSelecionado(Number(e.target.value))}
                    defaultValue={0}
                    style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                  >
                    <MenuItem key="0" value={0}>Selecione...</MenuItem>
                    {
                      AnosTemporadas.map(qtd =>
                        <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                      )
                    }
                  </Select>
                </FormControl>
              </Grid>
            )
            }
          </DialogContentText>

          {showDispensarJogador && <FormControlLabel
            sx={{
              display: 'block',
            }}
            control={
              <Switch
                checked={checked}
                onChange={handleChange}
                name="renovar"
                color="primary"
              />
            }
            label={dados.label}
          />
          }
          {showLanceFreeAgency && dadosLance !== undefined && (
            <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={3}>
              <Grid size={{ xs: 12, sm: 12 }} >
                <Typography sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 13 : "auto" }}>
                  Jogador: {dadosLance.nome_Jogador}
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }} >
                <TextField
                  fullWidth
                  name="valor_Ultimo_Contrato_Jogador"
                  //disabled={desativar}
                  label="Valor Salário"
                  value={lanceValor}
                  onChange={(e) => setLanceValor(e.target.value)}
                  slotProps={{
                    input: {
                      inputComponent: NumericFormatCustom as any,
                    },                    
                    inputLabel: {
                      style: {
                        fontSize: UtilidadeService.isMobile() ? 12 : "auto",                       
                      },
                      shrink: true,                      
                    }
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }} >
                <FormControl fullWidth>
                  <InputLabel id="anosFA">Anos</InputLabel>
                  <Select                    
                    label="Anos"
                    value={lanceAnoSelecionadoFA}
                    //disabled={desativar}
                    onChange={(e) => setLanceAnoSelecionadoFA(Number(e.target.value))}
                    defaultValue={0}
                    style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                  >
                    <MenuItem key="0" value={0}>Selecione...</MenuItem>
                    {
                      AnosTemporadas.map(qtd =>
                        <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                      )
                    }
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }} display={showOpcaoContrato ? "flex" : "none"} style={{ paddingTop: "20px" }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Opção Contrato Ajustável</InputLabel>
                  <Select
                    name="tipo_Contrato_Ajustavel"
                    label="Opção Contrato Ajustável"
                    value={opcaoContratoAjustavel}
                    onChange={(e) => { setOpcaoContratoAjustavel(Number(e.target.value)); }}
                    defaultValue={1}>
                    {
                      lstDropTipoContratoAjustado.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                    }
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          )}

          {showBaixaFinanceiro && dadosFinanceiro !== undefined && (
            <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={3}>
              <Grid size={{ xs: 12, sm: 12 }} >
                <Typography sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                  Dados Pagamento:
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }} >
                <TextField
                  fullWidth
                  name="valor_Pagamento"
                  //disabled={edicao && isLoading}
                  label="Valor Pagamento"
                  value={valorPagamento}
                  onChange={(e) => setValorPagamento(Number(e.target.value))}
                  style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14 }}
                  slotProps={{
                    input: {
                      inputComponent: NumericFormatCustom as any,
                    },
                    inputLabel: {
                      shrink: true,
                    }
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }} >
                <TextField
                  fullWidth
                  name="valor_Desconto"
                  label="Desconto"
                  value={descontoPagamento}
                  onChange={(e) => setDescontoPagamento(Number(e.target.value))}
                  style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14 }}
                  slotProps={{
                    input: {
                      inputComponent: NumericFormatCustom as any,
                    },
                    inputLabel: {
                      shrink: true,
                    }
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}  >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-fp">Forma Pagamento</InputLabel>
                  <Select
                    labelId="formaPagamento"
                    id="formaPagamento"
                    label="Forma Pagamento"
                    value={formaPagamento}
                    onChange={(e) => setFormaPagamento(Number(e.target.value))}
                    defaultValue={0}
                    style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                  >
                    <MenuItem key="0" value={0}>Selecione...</MenuItem>
                    {
                      enumFormasPagamento.filter(f => f.visible).map(qtd =>
                        <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                      )
                    }
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          )}

          {showDisponibilizarJogador && dadosDisponibilizarJogador !== undefined && (
            <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={3}>
              <Grid size={{ xs: 12, sm: 12 }} >
                <Typography sx={{ fontWeight: "bold" }}>
                  {dadosDisponibilizarJogador.mensagemAdicional.lenght >= 0 ? `TIPO: ${dadosDisponibilizarJogador.mensagemAdicional} ` : ""}
                </Typography>
              </Grid>
              {dadosDisponibilizarJogador.mensagemAdicional.length === 0 && (
                <Grid size={{ xs: 12, sm: 6, md: 6 }} >
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Tipo"
                      value={tipoAtivoTroca}
                      onChange={(e) => setTipoAtivoTroca(Number(e.target.value))}
                      defaultValue={0}
                      style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                    >
                      <MenuItem key="0" value={0}>Selecione...</MenuItem>
                      {
                        tipoDisponibilizacaoJogador.map(qtd =>
                          <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                        )
                      }
                    </Select>
                  </FormControl>
                </Grid>
              )}
            </Grid>
          )}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          {showLanceFreeAgency && <Button disabled={desativar} onClick={() => handleSalvarLance()} >Salvar</Button>}
          {showExcluirProposta && <Button onClick={() => handleExcluirProposta()} autoFocus>Excluir</Button>}
          {showBaixaFinanceiro && <Button disabled={desativar} onClick={() => handleBaixarFinanceiro()} autoFocus>Baixar Financeiro</Button>}
          {showDisponibilizarJogador && <Button disabled={desativar} onClick={() => handleDisponibilizarJogador()} autoFocus>Solicitar</Button>}
          {showAlterarContratoJogador && <Button disabled={desativar} onClick={() => handleAlterarContratoJogador()} autoFocus>Alterar</Button>}
          {showCancelarAposta && <Button disabled={desativar} onClick={() => handleCancelarAposta()} autoFocus>Sim</Button>}
        </DialogActions>
      </BootstrapDialog>
    </div >
  )
};